import { FilterCheckbox, translateCustomerType } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const CustomerTypeFilter = ({ filters, actions }: FilterItemsProps) => (
  <FilterListContainer id="customer-type-filter">
    <FilterCheckbox
      id="Individual"
      label={translateCustomerType("Individual")}
      checked={isChecked(filters.customerType, "Individual")}
      onCheckFilter={actions.setCustomerType}
      value="Individual"
    />

    <FilterCheckbox
      id="Business"
      label={translateCustomerType("Business")}
      checked={isChecked(filters.customerType, "Business")}
      onCheckFilter={actions.setCustomerType}
      value="Business"
    />
  </FilterListContainer>
);
